import React from "react";
import { Box } from "@mui/material";
import NavBar from "../NavBar/NavBar";
import ErrorComponent from "./Error";

export default function RootError(): React.ReactNode {
  return (
    <>
      <NavBar hasDrawer={false} />
      <Box sx={{ display: "flex", flexGrow: 1, mt: "64px" }}>
        <ErrorComponent />
      </Box>
    </>
  );
}
